import { render, staticRenderFns } from "./index-main.vue?vue&type=template&id=096f37aa&scoped=true&"
import script from "./index-main.vue?vue&type=script&lang=js&"
export * from "./index-main.vue?vue&type=script&lang=js&"
import style0 from "./index-main.vue?vue&type=style&index=0&id=096f37aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096f37aa",
  null
  
)

export default component.exports